var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 3.625C17.4375 3.625 17.75 3.9375 17.75 4.25V4.875C17.75 5.22656 17.4375 5.5 17.125 5.5H16.5L15.6406 18.7422C15.6016 19.7188 14.7422 20.5 13.7656 20.5H4.19531C3.21875 20.5 2.35938 19.7188 2.32031 18.7422L1.5 5.5H0.875C0.523438 5.5 0.25 5.22656 0.25 4.875V4.25C0.25 3.9375 0.523438 3.625 0.875 3.625H4.07812L5.40625 1.4375C5.71875 0.929688 6.42188 0.5 7.00781 0.5H10.9531C11.5391 0.5 12.2422 0.929688 12.5547 1.4375L13.8828 3.625H17.125ZM7.00781 2.375L6.26562 3.625H11.6953L10.9531 2.375H7.00781ZM13.7656 18.625L14.5859 5.5H3.375L4.19531 18.625H13.7656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash2.fbfd11fca9347f23590f6aa5b2b850b4.svg";
export { ForwardRef as ReactComponent };